export default {
  locale: {
    en: 'English',
    de: 'German',
  },
  app: {
    title: 'Vue Example App',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en.ts